export default "__VITE_ASSET__56caf97b__"